<template>
  <div>
    <ReportBaseSelectFilter
      v-if="!useLazySelect"
      class="project-filter"
      :label="projectLabel"
      :placeholder="projectPlaceholder"
      :options="options"
      :max-visible-options="2"
      query-property="projects"
    />

    <AppLazySelect
      v-else
      v-model="selected"
      eager
      multiple
      set-state-on-value-change
      class="project-filter"
      :resource="projectLabelSingular.toLowerCase()"
      :resource-label-plural="projectLabel.toLowerCase()"
      :label="projectLabel"
      :fetcher="fetcher"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { getProjectFlavourLabel } from '~/utils/project_flavour';
import { ReportsResource } from '~/resources';

export default {
  name: 'ReportProjectFilter',
  computed: {
    ...mapGetters(['allProjects', 'reportQuery', 'reportStartDate', 'reportEndDate', 'reportName', 'isTeam']),
    ...mapState({
      organization: 'organization',
      organizationId: (state) => state.organization_id || state.organization?.id,
      useLazySelect: 'use_lazy_project_select',
    }),
    options() {
      const archivedProjects = [];
      const result = [];

      if (this.allProjects) {
        this.allProjects.forEach((project) => {
          (project.archived ? archivedProjects : result).push({
            id: project.id,
            text: project.name,
          });
        });

        if (archivedProjects.length > 0) {
          result.push({
            text: 'Archived',
            children: archivedProjects,
          });
        }
      }

      return result;
    },
    projectLabelSingular() {
      return getProjectFlavourLabel(this.organization.project_flavour, false);
    },
    projectLabel() {
      return getProjectFlavourLabel(this.organization.project_flavour, true);
    },
    projectPlaceholder() {
      return `All ${this.projectLabel.toLowerCase()}`;
    },
    selected: {
      get() {
        return (this.reportQuery.filters.projects || []).map((id) => parseInt(id, 10));
      },
      set(projectIds = []) {
        this.updateSearch({ projects: projectIds });
      },
    },
  },
  methods: {
    ...mapActions(['updateSearch']),
    fetcher(payload) {
      const finalPayload = {
        ...payload,
        report_date: this.reportStartDate,
        report_date_end: this.reportEndDate,
        report_name: this.reportName,
        mine: !this.isTeam,
        filters: {
          ...(payload.filters || {}),
          append_archived_label: true,
        },
      };

      return ReportsResource.projects({ organization_id: this.organizationId }, finalPayload, {
        abortReload: true,
      });
    },
  },
};
</script>
